import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckPermissions } from './Shared';

const ReportCamerasOnHireData = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        var hasPermission = await CheckPermissions("RunReports");
        if (hasPermission) {
            setLoading(false);
        } else {
            navigate("/accessdenied");
        }
    }

    const runReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data
        runRpt();
    }

    const runRpt = () => {
        var url = "/report/CamerasOnHire/-1/-1/-1/-1/-1";
        window.open(url, '_blank');
    }

    const renderDetails = (
        <div>
            <div>
                <h1>Cameras On Hire Report</h1>
            </div>
            <div>
                <button className="defaultbutton" type='button' onClick={runReport}>Run Report</button>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)

}

export default ReportCamerasOnHireData;